<!-- Body -->
    <!-- News header -->
    <div class="swapa-news-header">
        <h1>{{staticContent?.NewsPageTitle}}</h1>
        <div class="row justify-content-end align-items-center">
            <div class="col-12 col-md-auto">
                <label class="input-group d-flex align-items-center">
                    <span class="input-group-prepend text-primary pr-2">
                        Filter by
                    </span>
                    <select required class="form-control d-inline-block" name="dnFilterText"
                       #dnFilterText (change)="onFilterChange($event)">
                        <option value="0" selected>No filter</option>
                        <option *ngFor="let value of filterbyValues" value={{value}}>{{value}}</option>
                    </select>
                </label>
            </div>
            <div class="col-12 col-md-auto">
                <label class="input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text">
                            <div class="swapa-search"></div>
                        </span>
                    </div>
                    <input [(ngModel)]="searchText" type="text"
                           class="form-control"
                           name="txtSearch"
                           #txtSearch
                           placeholder="Search Articles" />
                </label>
            </div>
        </div>
    </div>

        <!-- News articles -->
    <div class="swapa-body">
        <h2 *ngIf="filteredArticles.length==0 || searchedArticles.length==0">{{noSearchText}}</h2>
        <h2 [hidden]="!loadingText">Loading ...</h2>
            <article class="row" *ngFor="let article of newsArticles | slice: (page-1) * pageSize : (page-1) * pageSize + pageSize">
                <div class="col-12 col-md-4 mb-2 mb-md-0">
                    <img class="cover"
                         src="{{article.ImagePath}}"
                         alt=""
                         width="100%"
                         height="200" />
                </div>
                <div class="col-12 col-md">
                    <a href="{{article.Url}}">
                        <h3 class="text-uppercase">
                            {{article.NewsTitle}}
                        </h3>
                        {{article.NewsDate}}
                    </a>
                    <ng-container *ngIf="article.ArticleTypeTagText">
                        | <a href="{{article.ArticleTypeTagUrl}}">{{article.ArticleTypeTagText}}</a><span>, </span>
                    </ng-container>
                    <ng-container *ngFor="let category of article.Categories; let first = first; let last = last;"> 
                        <span *ngIf="first && !article.ArticleTypeTagText"> | </span> <a href="{{staticContent?.FilterUrl}}{{category.UrlFriendlyName}}">{{category.Description}}</a><span *ngIf="!last">, </span>
                    </ng-container>
                    <p>
                        {{article.NewsSummary }}
                    </p>
                </div>
            </article>
    </div>

        <!-- News pagination -->
        <div *ngIf="newsArticles?.length>0" class="row justify-content-center justify-content-md-between align-items-center">
            <div class="col-12 col-md-auto text-center">
                <span>Showing {{endIndex}} of {{ newsArticles.length }} results</span>
            </div>
            <div class="col-auto">
                <!--<app-newsarticle-pagination [items]="newsArticles" (changePage)="onChangePage($event)"></app-newsarticle-pagination>-->
                <ngb-pagination [collectionSize]="newsArticles.length" [(page)]="page" [pageSize]="pageSize" [maxSize]="3" [rotate]="true" [boundaryLinks]="false" (pageChange)="onChangePage($event)" aria-label="Default pagination">
                </ngb-pagination>
            </div>
        </div>